import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { ParlamentarianSearchProvider } from './context/parlamentarian-search-context';
import { ParlamentarianSearchComponent } from './parlamentarian-search-component';

export function ParlamentarianSearchFactory() {
    return (
        <BaseLayoutFactory>
            <ParlamentarianSearchProvider>
                <ParlamentarianSearchComponent />
            </ParlamentarianSearchProvider>
        </BaseLayoutFactory>
    );
}
